import { Archive, Check, Clock3 } from "lucide-react";

type Status = "confirmed" | "needs-review" | "archived" | "current" | "approved" | "draft";

const labels: Record<Status, string> = {
  confirmed: "Подтверждено",
  "needs-review": "Требует проверки",
  archived: "Архив",
  current: "Актуальная версия",
  approved: "Одобрено",
  draft: "Черновик",
};

export function StatusBadge({ status }: { status: Status }) {
  const Icon = status === "confirmed" || status === "current" || status === "approved" ? Check : status === "archived" ? Archive : Clock3;
  return (
    <span className={`badge badge--${status}`}>
      <Icon size={13} strokeWidth={2.2} aria-hidden="true" />
      {labels[status]}
    </span>
  );
}
